import { listMenu } from "@/api/system/menu";
import { listSettingComponentType } from "@/api/setting/settingComponentType";
/**
 * presetFunction_
 */
export default {
    /** 菜单 presetFunction_menuList */
    menuList: {
        queryFunction: listMenu,
        extendQueryWhere: { menuType: 'M-C' },
        fieldNames: { value: 'menuId', label: 'menuName', children: 'children', parentId: 'parentId', treeCode: 'treeCode' }
    },
    /** 菜单 presetFunction_settingComponentType */
    settingComponentType: {
        queryFunction: listSettingComponentType,
        extendQueryWhere: {},
        fieldNames: { value: 'componentTypeId', label: 'componentTypeName', children: 'children', parentId: 'parentTypeId', treeCode: 'componentTypeCode' }
    },
}